import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../../../components/Hotel/Box/Tile/components/Container.js';
export const Tile = forwardRef(function HotelTile({
  children,
  ...otherProps
}, ref) {
  return _jsx(Container, {
    ...otherProps,
    ref: ref,
    children: children
  });
});